{
	"common": {
		"save": "Save",
		"skip": "Skip",
		"back": "Back",
		"cancel": "Cancel",
		"delete": "Delete",
		"create-new": "Create new",
		"and-others_one": "and {{count}} other",
		"and-others_other": "and {{count}} others"
	},
	"org-interpolations": {
		"default": {
			"caregivers": "Caregivers",
			"caregiver": "Caregiver",
			"care-recipients": "Care Recipients",
			"care-recipient": "Care Recipient"
		},
		"education": {
			"caregivers": "Teachers",
			"caregiver": "Teacher",
			"care-recipients": "Students",
			"care-recipient": "Student"
		}
	},
	"my-organisations": "My organizations",
	"my-role": "My role: ",
	"organisation-not-found": "Organization not found",
	"settings": "Settings",
	"tab-label-caregivers": "{{caregivers}}",
	"tab-label-care-recipients": "{{care-recipients}}",
	"tab-label-archived": "Archived",
	"tab-label-familycaregivers": "Family caregivers",
	"tab-label-temporary-access": "Temporary access",
	"table": {
		"header": {
			"name": "Name",
			"username": "Username",
			"role": "Role",
			"email": "Email",
			"requester": "Requester",
			"care-recipient": "{{care-recipient}}",
			"access-end-date": "Access end date"
		},
		"actions": {
			"edit": "Edit",
			"archive": "Archive",
			"unarchive": "Unarchive",
			"assign-caregiver": "Assign {{caregiver}}",
			"reset-password": "Reset password",
			"assign-to-teams": "Assign to teams",
			"remove-from-team": "Remove from team",
			"invite-family-member": "Invite family member",
			"view-profile": "View profile",
			"accept": "Accept",
			"reject": "Reject",
			"temporary-access": "Temporary access",
			"revoke-access": "Revoke access",
			"deny-pletly-access": "Deny Pletly access"
		}
	},
	"toasts": {
		"success": {
			"role-updated": "Role updated",
			"member-archived": "User archived",
			"member-restored": "Member restored",
			"caregivers-assigned": "{{caregivers}} have been assigned",
			"employee-created": "{{caregiver}} has been created",
			"care-recipient-created": "{{care-recipient}} has been created",
			"profile-saved": "Profile has been saved",
			"reset-password-mail-sent": "Reset password link sent with e-mail",
			"team-created": "Team has been created",
			"team-updated": "Team has been updated",
			"teams-assigned": "Teams have been assigned",
			"members-added-to-team": "Members have been added to the team",
			"member-removed-from-team": "Member has been removed from the team",
			"invitation-accept-title": "Accepted",
			"invitation-accept-content": "Successfully accepted the connection request",
			"invitation-reject-title": "Rejected",
			"invitation-reject-content": "You have rejected the connection request",
			"organization-updated": "Organization has been updated",
			"temporary-access-invite-sent": "Temporary access invite has been sent",
			"temporary-access-revoked": "Temporary access has been revoked",
			"family-caregiver-disconnected": "Family caregiver has been disconnected"
		},
		"error": {
			"something-wrong": "Something went wrong",
			"no-care-recipients-selected": "No {{care-recipients}} selected"
		}
	},
	"new-employee": "New {{caregiver}}",
	"assign": "Assign",
	"assign-caregivers-to": "Assign {{caregivers}} to {{name}}",
	"inputs": {
		"organization-name": "Organization name"
	},
	"create-account-for-employee": "Create account for {{caregiver}}",
	"create-account-for-care-recipient": "Create account for {{care-recipient}}",
	"care-recipient-created-confirmation": {
		"title": "You have successfully created an account for {{name}}",
		"subtitle": "Do you want to provide more details about your {{care-recipient}} to help other {{caregivers}} better understand their needs?",
		"ctaButton": "Add information",
		"secondaryButton": "Assign {{caregivers}}"
	},
	"fill-care-recipient-information": {
		"title": "Add information about {{care-recipient}}"
	},
	"fill-information-confirmation": {
		"title": "Thank you!\nAdditional information is always helpful!",
		"subtitle": "You can assign {{caregivers}} to {{name}}",
		"ctaButton": "Assign {{caregivers}}"
	},
	"teams": {
		"teams": "Teams",
		"other-teams": "Other teams",
		"new-team": "New team",
		"edit-team": "Edit team",
		"form": {
			"label-name": "Team name",
			"label-posts-screening": "Posts screening",
			"post-screening-disabled-info": "At least one Team Admin is required to change this setting"
		},
		"team-not-found": "Team not found",
		"no-teams-yet": "No teams have been created yet.",
		"no-other-teams-created": "No other teams have been created.",
		"new-sub-team": "New sub-team",
		"delete": {
			"label-description": "This action will delete the team and it cannot be undone.",
			"delete-team": "Delete team",
			"are-you-sure-you-want-to-delete-the-name-team": "Are you sure you want to delete the {{ name }} team?",
			"this-will-also-remove-its-sub-teams-if-any": "This will also remove its nested teams.",
			"team-deleted": "Team deleted",
			"if-you-want-also-to-disconnect-caregivers-or-care-recipients-inside-team-please-do-so-first": "If you want also to disconnect {{caregivers}} or {{care-recipients}} inside team, please do so first."
		},
		"help-content": "Teams in Pletly let you manage caregiver access more easily. When you add a caregiver to a team, they automatically get access to all care recipients in that team. Add a care recipient to the team, and all caregivers in it will be connected. Remove someone from the team, and the connection is removed too.\n\nYou can also create sub-teams. Caregivers in the main team will still have access to care recipients in its sub-teams, even if they’re not directly added there."
	},
	"assign-to-teams": "Assign to teams",
	"add-caregivers-to-team": "Add {{caregivers}} to the team",
	"add-care-recipients-to-team": "Add {{care-recipients}} to the team",
	"no-members-to-add": "No members to add",
	"confirmations": {
		"remove-from-team": {
			"title": "Remove {{name}} from the team?",
			"content-caregiver": "Removing a {{caregiver}} from a team will disconnect them from all {{care-recipients}} belonging to that team.",
			"content-care-recipient": "Removing a {{care-recipient}} from a team will disconnect them from all {{caregivers}} belonging to that team."
		},
		"accept-invitation": {
			"title": "Accept connection request?",
			"content": "Are you sure you want to accept {{requesterName}}'s request to become {{careRecipientName}}'s Family Caregiver?"
		},
		"reject-invitation": {
			"title": "Reject connection request?",
			"content": "Are you sure you want to reject {{requesterName}}'s request to become {{careRecipientName}}'s Family Caregiver?"
		},
		"revoke-temporary-access": {
			"title": "Revoke temporary access?",
			"content": "Are you sure you want to revoke {{caregiverEmail}}'s temporary access to {{careRecipientName}}'s profile?"
		},
		"archive-organisation-member": {
			"title": "Archive user",
			"content": "Are you sure you want to archive {{name}}?"
		},
		"unarchive-organisation-member": {
			"title": "Restore user",
			"content": "Are you sure you want to restore {{name}}'s account?"
		},
		"block-organisation-member-login": {
			"title": "Disallow user to use Pletly",
			"content": "Access can be turned on later, by setting a new password. \n\n Are you sure you want to block login for {{name}}?"
		}
	},
	"terms-of-use": {
		"title": "Terms of Use",
		"manage-terms-of-use": "Manage Terms of Use",
		"terms-of-use-accepted": "Terms of Use accepted",
		"i-agree-to-the-terms-of-use-as-outlined-by": "I agree to the Terms of Use as outlined by",
		"members-who-accepted": "Members who accepted",
		"new-version": "New version",
		"accepted": "Accepted",
		"table": {
			"updated-at": "Updated at",
			"members-accepted": "Members accepted",
			"text": "Text"
		},
		"terms-of-use-created": "Terms of use created",
		"new-terms-of-use": "New Terms of use",
		"new-terms-of-use-field-placeholder": "Terms of use",
		"accept": "Accept"
	},
	"connection-requests": {
		"title": "Connection requests",
		"view-all": "View all requests"
	},
	"telephone": "Telephone",
	"import-care-recipient": "Import {{care-recipient}}",
	"enter-the-care-recipients-unique-username-to-send-an-import-request-to-the-account-owner": "Enter the Care Recipient’s unique username to send an import request to the account owner.",
	"request-sent": "Request sent",
	"request-has-been-sent-to-the-care-receiver-guardian": "Request has been sent to the {{care-recipient}}'s guardian",
	"add-new": "Add new",
	"create-new-care-recipient": "Create new {{care-recipient}}",
	"new-post": "New post",
	"edit-organization": "Edit organization",
	"temporary-access": {
		"title": "Temporary access",
		"send-invite": "Send invite",
		"label-access-duration": "Access duration",
		"label-custom-duration": "Duration",
		"label-select-care-recipients": "Selected {{care-recipients}}",
		"placeholder-select-care-recipients": "Select {{care-recipients}}",
		"new-button": "New temporary access"
	},
	"roles": {
		"member": "{{caregiver}}",
		"manager": "System manager",
		"care-recipient": "{{care-recipient}}",
		"team-admin": "Team Admin"
	},
	"allow-care-recipient-to-use-pletly": "Allow {{care-recipient}} to use Pletly",
	"family-caregiver-connections-modal": {
		"title": "Family caregiver connections",
		"button-disconnect": "Disconnect",
		"confirm-disconnect": {
			"title": "Disconnect family caregiver",
			"content": "Are you sure you want to disconnect {{caregiverName}} and {{careRecipientName}}?"
		},
		"connections-list-empty": "The connections list is empty"
	},
	"request-ownership": "Request Ownership",
	"no-email": "No email",
	"initial-password-for-first-login": "Initial password for first login"
}
